<div class="grid">
  @for(s of sources; track s.id){

  <div
    class="select"
    [ngClass]="{
      'ai-boder-animation': isSelected(s.id),
      isSelected: isSelected(s.id)
    }"
    (click)="onSelect(s.id)"
    appMarqueeOnHover=".marquee"
  >
    <!-- Deep-link into the knowledge base page for this bucket. Sits
         opposite the checkbox and stops propagation so opening never
         toggles the assignment. Only rendered when the data source is
         bucket-backed (has a resolvable bucket id) — not for a lecturer's
         internal folder, which the Wissensbasis page does not list (#230). -->
    @if(bucketIdOf(s) && !isSystem(s)){
    <button
      type="button"
      class="open-kb"
      [attr.title]="'pages.tutors.knowledgeBase.openBucket' | translate"
      [attr.aria-label]="'pages.tutors.knowledgeBase.openBucket' | translate"
      (click)="openBucket(s, $event)"
    >
      <nb-icon icon="external-link-outline"></nb-icon>
    </button>
    }

    <div class="background">
      <nb-checkbox
        style="pointer-events: none"
        [checked]="isSelected(s.id)"
      ></nb-checkbox>
      <nb-icon
        [status]="isSelected(s.id) ? 'primary' : ''"
        icon="knowledge"
        pack="al"
      ></nb-icon>
      <p class="marquee">{{ s | knowledgeSourceName | async }}</p>
    </div>
  </div>
  }

  <div style="height: 300px"></div>
</div>
